<span
    class="streaming-icon"
    role="img"
    [attr.aria-label]="alt || name"
    [style.color]="color"
    [innerHTML]="svgHtml"
></span>
